export default {"src":"/_next/static/media/exemptions-animation-cloud.966b5bb4.gif","height":1180,"width":1200,"blurWidth":0,"blurHeight":0};